<div class="label-container" #labelContainerEl>
  <div 
    #labelEl
    class="label" 
    [ngClass]="{
      'label--selected': (selectedLabel$ | async)?.id === label.id,
      'label--glow': label.pinGlow,
      'label--annotation': label.theme === 'annotation',
      'label--classic': label.theme === 'classic',
      'label--studio': label.theme === 'studioNext',
      'label--context': label.theme === 'context'
    }">
    
    <!-- Pin -->
    <div 
      #pin
      class="label__pin"
      [ngClass]="{
        'label__pin--plus': label.pinType === labelPinType.PlusMinus && (selectedLabel$ | async)?.id !== label.id,
        'label__pin--minus': label.pinType === labelPinType.PlusMinus && (selectedLabel$ | async)?.id === label.id
      }">
      <!-- Glow -->
      <div class="label__glow"></div>
    </div>

    <!-- Wire -->
    <div class="label__wire" [ngClass]="{'label__wire--collapse': tagCollapsed || label.hideWire }" #wire></div>

    <!-- Tag -->
    <div 
      #tag
      class="label__tag"
      [ngClass]="{'label__tag--collapse': tagCollapsed}">

      <div class="label__header">
        <div class="label__title" #title [innerHTML]="label.title"></div>
        
        <div class="label__icon text-dim" *ngIf="label.description && label.collapseDescription">
          <button app-button buttonSize="small" buttonTheme="light">
            <fa-icon 
              class="rotate--animate"
              [ngClass]="{ 'rotate-90': !descriptionCollapsed }"
              icon="caret-right"></fa-icon>
          </button>
        </div>
      </div>

      <div 
        class="label__body" 
        *ngIf="label.description" 
        [ngClass]="{'label__body--collapse': descriptionCollapsed}"
        [innerHTML]="label.description">
      </div>
    </div>
  </div>
</div>